<template>
  <main id="modules" v-if="oldModulesByUE != undefined">
    <div class="hubday-tabs">
      <div
        v-for="ue in Object.keys(oldModulesByUE).filter(k => k.startsWith('ue1-') || k.startsWith('ue2-'))"
        :key="ue"
        :id="ue"
        class="hubday-tab"
        :class="ue + '-container'"
      >
        <div class="hubday-section">
          <div class="hubday-head">
            <i class="material-icons-outlined">school</i>
            {{ oldModulesByUE[ue].name }}
          </div>
          <div class="hubday-body">
            <div class="module" v-for="(matiere, id) in oldModulesByUE[ue].list" :key="matiere.name">
              <div class="background" :style="{backgroundColor: matiere.color}">
                <img :src="'img/modulesold/'+id+'.svg'" />
                <div class="infos">
                  <strong>- {{ id }} -</strong>
                  {{ (matiere.shortName ? matiere.shortName : matiere.name) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hubday-tabs2">
      <div
        v-for="ue in Object.keys(oldModulesByUE).filter(k => k.startsWith('ue3-'))"
        :key="ue"
        :id="ue"
        class="hubday-tab"
        :class="ue + '-container'"
      >
        <div class="hubday-section">
          <div class="hubday-head">
            <i class="material-icons-outlined">school</i>
            {{ oldModulesByUE[ue].name }}
          </div>
          <div class="hubday-body">
            <div class="module" v-for="(matiere, id) in oldModulesByUE[ue].list" :key="matiere.name">
              <div class="background" :style="{backgroundColor: matiere.color}">
                <img :src="'img/modulesold/'+id+'.svg'" />
                <div class="infos">
                  <strong>- {{ id }} -</strong>
                  {{ (matiere.shortName ? matiere.shortName : matiere.name) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<style>
.ue1-1-container .hubday-body,
.ue2-1-container .hubday-body {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px 10px;
  grid-template-areas: "module1 module2 module3" "module4 module5 module6";
}

.ue1-2-container .hubday-body,
.ue2-2-container .hubday-body {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 10px 10px;
  grid-template-areas: "module1 module1 module1 module2 module2 module2 module3 module3 module3 module4 module4 module4" "module5 module5 module5 module5 module6 module6 module6 module6 module7 module7 module7 module7";
}

.ue3-1-container .hubday-body,
.ue3-2-container .hubday-body {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(3, 1fr);
  gap: 10px 10px;
  grid-template-areas: "module1 module2" "module3 module4" "module5 module6";
}

.ue3-3-container .hubday-body {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, 1fr);
  gap: 10px 10px;
  grid-template-areas: "module1" "module2" "module3";
}

@media only screen and (min-width: 540px) and (max-width: 992px),
  (min-width: 993px) and (max-width: 1235px) {
  .ue3-1-container .hubday-body,
  .ue3-2-container .hubday-body {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 10px 10px;
    grid-template-areas: "module1 module2 module3" "module4 module5 module6";
  }
}

@media only screen and (min-width: 501px) and (max-width: 780px),
  (min-width: 993px) and (max-width: 1030px) {
  .ue3-3-container .hubday-body {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr;
    gap: 10px 10px;
    grid-template-areas: "module1 module2 module3";
  }
}

@media only screen and (min-width: 0px) and (max-width: 500px) {
  .ue3-3-container .hubday-body {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(2, 1fr);
    gap: 10px 10px;
    grid-template-areas: "module1 module2" "module3 module3";
  }
}

@media only screen and (min-width: 840px) and (max-width: 1430px),
  (min-width: 361px) and (max-width: 675px) {
  .ue1-1-container .hubday-body,
  .ue2-1-container .hubday-body {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-areas: "module1 module2" "module3 module4" "module5 module6";
  }

  .ue1-2-container .hubday-body,
  .ue2-2-container .hubday-body {
    grid-template-columns: repeat(6, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-template-areas: "module1 module1 module2 module2 module3 module3" "module4 module4 module4 module5 module5 module5" "module6 module6 module6 module7 module7 module7";
  }
}

@media only screen and (min-width: 993px) and (max-width: 1110px),
  (min-width: 361px) and (max-width: 460px) {
  .ue1-2-container .hubday-body,
  .ue2-2-container .hubday-body {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
    grid-template-areas: "module1 module2" "module3 module4" "module5 module6" "module7 module7";
  }
}

@media only screen and (max-width: 360px) {
  .ue1-1-container .hubday-body,
  .ue2-1-container .hubday-body {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 1fr);
    grid-template-areas: "module1" "module2" "module3" "module4" "module5" "module6";
  }

  .ue1-2-container .hubday-body,
  .ue2-2-container .hubday-body {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(7, 1fr);
    grid-template-areas: "module1" "module2" "module3" "module4" "module5" "module6" "module7";
  }

  .ue3-1-container .hubday-body,
  .ue3-2-container .hubday-body {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 1fr);
    grid-template-areas: "module1" "module2" "module3" "module4" "module5" "module6";
  }

  .ue3-3-container .hubday-body {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, 1fr);
    grid-template-areas: "module1" "module2" "module3";
  }
}

#modules .module:nth-child(1) {
  grid-area: module1;
}

#modules .module:nth-child(2) {
  grid-area: module2;
}

#modules .module:nth-child(3) {
  grid-area: module3;
}

#modules .module:nth-child(4) {
  grid-area: module4;
}

#modules .module:nth-child(5) {
  grid-area: module5;
}

#modules .module:nth-child(6) {
  grid-area: module6;
}

#modules .module:nth-child(7) {
  grid-area: module7;
}

#modules .module {
  height: 150px;
}

#modules .module .background {
  border-radius: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  color: white;
  font-weight: normal;
  text-align: center;
  padding: 10px;
}

#modules .module .background img {
  width: 64px;
}

#modules .module .background .infos {
  display: flex;
  flex-direction: column;
  font-size: 14px;
}

#modules .module .background .infos strong {
  font-weight: 600;
  font-size: 15px;
}

#modules {
  display: block;
}
</style>

<style scoped>
.hubday-tabs,
.hubday-tabs2 {
  max-width: 1200px;
  margin: auto;
}

.hubday-tabs {
  margin-bottom: -8px;
}

.ue1-1-container {
  grid-area: ue1-1-container;
}

.ue1-2-container {
  grid-area: ue1-2-container;
}

.ue2-1-container {
  grid-area: ue2-1-container;
}

.ue2-2-container {
  grid-area: ue2-2-container;
}

.ue3-1-container {
  grid-area: ue3-1-container;
}

.ue3-2-container {
  grid-area: ue3-2-container;
}

.ue3-3-container {
  grid-area: ue3-3-container;
}

@media only screen and (min-width: 601px) {
  .hubday-tabs {
    display: grid;
    grid-template-columns: 3fr 4fr;
    grid-template-rows: auto 1fr;
    gap: 12px 12px;
    grid-template-areas: "ue1-1-container ue1-2-container" "ue2-1-container ue2-2-container";
  }

  .hubday-tabs2 {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-template-rows: 1fr;
    gap: 12px 12px;
    grid-template-areas: "ue3-1-container ue3-1-container ue3-2-container ue3-2-container ue3-3-container";
  }
}

@media only screen and (min-width: 993px) and (max-width: 1110px) {
  .hubday-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 1fr;
    gap: 12px 12px;
    grid-template-areas: "ue1-1-container ue2-1-container" "ue1-2-container ue2-2-container";
  }
}

@media only screen and (min-width: 601px) and (max-width: 1235px) {
  .hubday-tabs2 {
    display: grid;
    grid-template-columns: 3fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 12px 12px;
    grid-template-areas: "ue3-1-container ue3-3-container" "ue3-2-container ue3-3-container";
  }
}

@media only screen and (min-width: 993px) and (max-width: 1030px),
  (min-width: 0px) and (max-width: 780px) {
  .hubday-tabs2 {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr auto;
    gap: 12px 12px;
    grid-template-areas: "ue3-1-container" "ue3-2-container" "ue3-3-container";
  }
}

@media only screen and (max-width: 840px) {
  .hubday-tabs {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
    gap: 12px 12px;
    grid-template-areas: "ue1-1-container" "ue1-2-container" "ue2-1-container" "ue2-2-container";
  }
}
</style>

<script>
import { mapState } from "vuex";

import * as firebase from "firebase/app";
import "firebase/database";
const rtdb = firebase.database();
var modulesRef = rtdb.ref("modules");

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapState(["userProfile", "oldModulesByUE"]),
  },
  methods: {},
  mounted() {
  },
};
</script>